import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToFastForwardTap = (
    fastForwardTap$: Observable<void>,
    playbackStore: IPlaybackStore
): Subscription =>
    fastForwardTap$
        .subscribe(() => playbackStore.actions.fastForward());

export default subscribeToFastForwardTap;